import React from "react";

const Blogs = () => {
  return (
    <div className="grid md:grid-cols-2 m-6 gap-10 ">
      <div className="bg-[#8dd9eca2] p-6 rounded-xl">
        <h1 className="text-2xl font-semibold my-3">
          Q:What is a context api?
        </h1>
        <p>
          Ans:আমরা রিঅ্যাক্ট এ সাধারণত একটা কম্পোনেন্ট থেকে আরেকটা কম্পোনেন্ট এ
          ডাটা সেন্ড করি। সেক্ষেত্রে একটা কম্পোনেন্ট এর ডাটা আরেকটা চাইল্ড
          কম্পোনেন্ট এ props হিসাবে পাঠাতে হয়। অনেকসময় আমাদের মেইন কম্পোনেন্ট
          যেখানে ডাটা রয়েছে সেখান থেকে চাইল্ড কম্পোনেন্ট অনেক লেভেল নিচে থাকে।
          তখন props drilling করে ডাটা পাঠাতে অনেক অসুবিধা হয়। এই অসুবিধা থেকে
          বাঁচার জন্য আমরা context api ব্যবহার করি। React.createContext() এটি
          Provider এবং consumer return করে। প্যারেন্ট component যে ডাটা provide
          করবে সেটি value মধ্যে দিয়ে দেয়। তখন যেকোন চাইল্ড সে ডাটা ইউজ করতে
          পারে।
        </p>
      </div>
      <div className="bg-[#8dd9eca2] p-6 rounded-xl">
        <h1 className="text-2xl font-semibold my-3">Q:What is semantic tag?</h1>
        <p>
          Ans:একটি সিমেন্টিক এলিমেন্ট ব্রাউজার এবং ডেভেলপার উভয়ের কাছে
          স্পষ্টভাবে এর অর্থ বর্ণনা করে। সিমেন্টিক এলিমেন্টের নাম দেখেই
          এলিমেন্টের কন্টেন্টগুলো সম্পর্কে আমরা ধারনা পাবো। নন-সিমেন্টিক
          এলিমেন্ট তাদের কন্টেন্ট সম্পর্কে কিছুই বর্ণনা করে না। সিমেন্টিক
          এলিমেন্টগুলো দেখলেই বুঝতে পারি এর কন্টেন্টে কি থাকবে। নিচে এদের কিছু
          এলিমেন্ট দেয়া হলো :<li>article</li>
          <li>header</li>
          <li>footer</li>
          <li>main</li>
          <li>nav</li>
          <li>summary</li>
        </p>
      </div>

      <div className="bg-[#8dd9eca2] p-6 rounded-xl">
        <h1 className="text-2xl font-semibold my-3">
          Q:What is the difference between inline block and inline-block??
        </h1>
        <p>
          Ans:
          <p>
            <b>inline</b> element একটি নতুন লাইনে শুরু হয় না এবং কেবলমাত্র এটির
            প্রয়োজন width দখল করে। inline element এর height width সেট করতে
            পারবেন না।
          </p>
          <p>
            <b>block</b>element একটি নতুন লাইনে শুরু হবে এবং পুরো width দখল
            করবে। এবং আপনি height width সেট করতে পারেন।
          </p>
          <p>
            <b>inline-block</b> এটি inline element এর মতো format করা হয়েছে,
            যেখানে এটি একটি নতুন লাইনে শুরু হয় না। কিন্তু, আপনি height width সেট করতে পারেন।
          </p>
        </p>
      </div>
    </div>
  );
};

export default Blogs;
